export default "__VITE_ASSET__d0cbce4b__"